export default {
  "b2b.rezervace.widget.title.nejblizsi": "Nejbližší rezervace",
  "b2b.rezervace.widget.title-action.download": "Plný časový plán"
};
